export const APP_VERSION = '0.1.1';
export const BUILD_DATE = '2026-11-03T11:26:51Z';
export const COMMIT_HASH = 'c8f79f9e';
export const BUILD_DATE_UTC = '2026-11-03T11:26:51Z';
export const BUILD_DATE_IST = '2026-11-03T16:56:51+05:30';
export const ENVIRONMENT = 'stage';
